import { render, staticRenderFns } from "./RoboPerdida.vue?vue&type=template&id=364c216a"
import script from "./RoboPerdida.vue?vue&type=script&lang=js"
export * from "./RoboPerdida.vue?vue&type=script&lang=js"
import style0 from "./RoboPerdida.vue?vue&type=style&index=0&id=364c216a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports